module.exports = __webpack_public_path__ + "img/notification.5304f924.svg";